module.exports = __webpack_public_path__ + "static/media/icon_bedroom.d901e767.svg";